import { RootState } from 'types'
import { setSessionStorage } from 'utils/sessionStorage'
import { ALMANAC_CORE_WORKSPACE_ID } from './constants'

const WORKSPACE_CACHE_KEY = 'almanacWorkspace'

const setWorkspaces = (workspaces: RootState['workspace']) => {
  setSessionStorage(WORKSPACE_CACHE_KEY, workspaces)
}

const getWorkspaces = () => {
  return (
    JSON.parse(sessionStorage.getItem(WORKSPACE_CACHE_KEY) || 'null') || {
      workspaces: [],
      currentWorkspaceId: ALMANAC_CORE_WORKSPACE_ID,
    }
  )
}

const clear = () => {
  sessionStorage.removeItem(WORKSPACE_CACHE_KEY)
}

const workspaceSessionStorage = {
  setWorkspaces,
  getWorkspaces,
  clear,
}

export default workspaceSessionStorage
